import React, { useCallback, useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
import * as Style from "../inventory/styles/inventory";
import asset from "../../../../assets/images/asset.png";
import tableimg from "../../../../assets/images/big/camera.png";
import Loader from "../../../styled-components/loader/loader";
import { Modal, Form, Button, Icon } from "antd";
import PropertyAdd from "./property/property-add";
import RoomAdd from "./Room/room-add";
import PropertyUpdate from "./property/property-update";
import swal from "sweetalert";
import RoomUpdate from "./Room/room-update";
import { Link, useHistory } from "react-router-dom";
import { defaultStyles } from "../../../../constants/style-constants/utils";
// import addIcon from "../../../../assets/SVGs/android-chrome-512x512.png";
import addIcon from "../../../../assets/images/DeathModuleNew/addIcon.png";
import { BorrowItemModal } from "./modals/BorrowItemModal";
import { LoanItemModal } from "./modals/LoanItemModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  saveActiveProperty,
  saveAllProperties,
} from "../../../../redux/slices/propertiesSlice";
import {
  saveActiveRoom,
  saveAllRooms,
} from "../../../../redux/slices/roomsSlice";
import {
  saveAllItems,
  saveActiveItem,
} from "../../../../redux/slices/itemsSlice";
import moment from "moment";

function inventory(props) {
  const { colors } = defaultStyles;
  const [allProperties, setAllProperties] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const [totalValues, setTotalValues] = useState(0);
  const [detailsModal, setDetailsModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);

  const [activeRoom, setActiveRoom] = useState();
  const [allRooms, setAllRooms] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [allHeading, setHeading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showPropertyAdd, setShowPropertyAdd] = useState(false);
  const [showRoomAdd, setShowRoomAdd] = useState(false);
  const [showItemAdd, setShowItemAdd] = useState(false);
  const [parentId, setParentId] = useState();
  const [roomId, setRoomId] = useState();
  const history = useHistory();
  const [data, setData] = useState(false);
  const [updateProperty, setUpdateProperty] = useState({});
  const [showUpdateProperty, setShowUpdateProperty] = useState(false);
  const [updateRoom, setUpdateRoom] = useState({});
  const [showUpdateRoom, setShowUpdateRoom] = useState(false);
  const [updateItem, setUpdateItem] = useState({});
  const [showUpdateItem, setShowUpdateItem] = useState(false);
  const [editItemDetails, setEditItemDetails] = useState({});
  const { propertiesInfo, roomsInfo, itemsInfo } = useSelector(
    (state) => state.rootReducer
  );

  const [addLoanModal, setAddLoanModal] = useState(false);
  const [addBorrowModal, setAddBorrowModal] = useState(false);
  const [formDataLoan, setFormDataLoan] = useState(null);
  const [formDataBorrow, setFormDataBorrow] = useState(null);

  const handleInputChangeLoan = (name, value) => {
    setFormDataLoan({
      ...formDataLoan,
      [name]: value,
    });
  };
  const handleInputChangeBorrow = (name, value) => {
    setFormDataBorrow({
      ...formDataBorrow,
      [name]: value,
    });
  };
  const handleCancelAddLoanModal = () => {
    setAddLoanModal(false);
    setFormDataLoan(null);
  };
  const handleCancelAddBorrowModal = () => {
    setAddBorrowModal(false);
    setFormDataBorrow(null);
  };

  const handleSaveAddLoanModal = async () => {
    setAddLoanModal(false);
    try {
      const fetchroomInfo =
        roomsInfo && roomsInfo.allrooms
          ? roomsInfo.allrooms.find(
              (room) =>
                room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
            )
          : null;
      let payload = {
        ...formDataLoan,
        roomId: (roomId && roomId.id) || (fetchroomInfo && fetchroomInfo.id),
        propertyId: parentId ? parentId.id : activeItem.id,
      };
      console.log("formDataLoan", payload);
      setIsLoading(true);
      let data = await MODULE_API.loanItemCreate(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        if (roomId) {
          await fetchItem(roomId);
        }
        // await getCarryForward();
      }
      if (data && data.status === 400) {
        swal("Oops!", data.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setFormDataLoan(null);
  };
  const handleReturnItem = async (itemId) => {
    setAddBorrowModal(false);
    try {
      const fetchroomInfo =
        roomsInfo && roomsInfo.allrooms
          ? roomsInfo.allrooms.find(
              (room) =>
                room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
            )
          : null;
      let payload = {
        // ...formDataBorrow,
        itemId: itemId,
        // roomId: roomId && roomId.id || (fetchroomInfo && fetchroomInfo.id),
        // propertyId: parentId ? parentId.id : activeItem.id,
      };
      console.log("formDataBorrow", payload);
      setIsLoading(true);
      let data = await MODULE_API.loanItemUpdate(itemId, payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        if (roomId) {
          await fetchItem(roomId);
        }
        // await getCarryForward();
      }
      if (data && data.status === 400) {
        swal("Oops!", data.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setFormDataBorrow(null);
  };
  const handleSaveAddBorrowModal = async () => {
    setAddBorrowModal(false);
    try {
      const fetchroomInfo =
        roomsInfo && roomsInfo.allrooms
          ? roomsInfo.allrooms.find(
              (room) =>
                room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
            )
          : null;
      let payload = {
        ...formDataBorrow,
        roomId: (roomId && roomId.id) || (fetchroomInfo && fetchroomInfo.id),
        propertyId: parentId ? parentId.id : activeItem.id,
      };
      console.log("formDataBorrow", payload);
      setIsLoading(true);
      let data = await MODULE_API.borrowItemCreate(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
        // await getCarryForward();
      }
      if (data && data.status === 400) {
        swal("Oops!", data.message, "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setFormDataBorrow(null);
  };

  useEffect(() => {
    if (propertiesInfo.activeProperty.id) {
      setActiveItem(
        propertiesInfo &&
          propertiesInfo.allProperties &&
          propertiesInfo.allProperties.find(
            (item) => item.id === propertiesInfo.activeProperty.id
          )
      );
    }
    console.log("active item", propertiesInfo.activeProperty);
  }, [propertiesInfo]);
  const dispatch = useDispatch();
  const updateInventory = useCallback((item) => {
    fetchRoom(item);
    handleModalCancel();
  }, []);
  const updateProperties = useCallback(() => {
    setAllProperties([]);
    inventoryReport();
    console.log("add properites");
    handleModalCancel();
  }, []);

  React.useEffect(() => {
    inventoryReport();
  }, []);
  // useEffect(()=>{
  //   if(allRooms && allRooms.length>0){
  //     fetchItem(allRooms[0])
  //   }
  // },[])

  const getSelectedRecords = async (record, name) => {
    setDetailsModal(true);
    console.log("record to edit", record);
    if (name === "Images") {
      setCurrentRecord({
        files: record.multiImg ? record.multiImg : [],
        name: name,
      });
    } else {
      setCurrentRecord({
        files: record.videos ? record.videos : [],
        name: name,
      });
    }
  };
  const handleCancel = () => {
    setCurrentRecord(null);
    setDetailsModal(false);
  };

  let propertiesList = [];
  let roomsList = [];
  let rooms = [];
  const styles = {
    hidescroll: {
      width: "100%",
      overflow: "hidden",
    },
    container: {
      width: "100%",
      overflowX: "auto",
      paddingBottom: 20,
      marginBottom: -20,
    },
  };

  async function addProperty() {
    setShowPropertyAdd(true);
    setModal(true);
  }

  async function addRoom() {
    setShowRoomAdd(true);
    setModal(true);
  }

  async function addItem() {
    setShowItemAdd(true);
    const fetchroomInfo =
      roomsInfo && roomsInfo.allrooms
        ? roomsInfo.allrooms.find(
            (room) =>
              room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
          )
        : null;
    history.push(
      `/add_item/${parentId ? parentId.id : activeItem.id}/${
        roomId ? roomId.id : fetchroomInfo.id
      }`,
      { property: { ...parentId, room: roomId } }
    );
  }

  async function fetchItem(itemsList) {
    console.log("fetchItem", itemsList);
    setRoomId(itemsList);
    setActiveRoom(itemsList.id);
    setIsLoading(true);
    let item = await MODULE_API.fetchRooms({
      id: itemsList.id,
      body: {},
    });
    // console.log("rooms listing", item);
    setIsLoading(false);
    if (item.data && item.data.children && item.data.children.length === 0) {
      setData(true);
    } else {
      setData(false);
    }
    item =
      item.data &&
      item.data.children &&
      item.data.children.map((items) => ({
        id: items.id,
        room: item.data ? item.data.name : "N/A",
        name: items.name ? items.name : "N/A",
        quantity: items.quantity ? items.quantity : "N/A",
        value: item.data ? item.data.total : 0,
        currentValue: items.currentValue,
        isLoan: items.isLoan,
        img: items.images && items.images[0] ? items.images[0] : tableimg,
      }));
    console.log("iteeeeee", item);
    setAllItems(item);
    setShowItems(true);
    // console.log("items listing", item);
    // setTimeout(() => {
    //   getAllItems(itemsList.id);
    // }, 500);
    dispatch(saveActiveRoom({ id: itemsList.id, children: item }));
    dispatch(saveAllItems(item));
  }

  async function fetchRoom(item) {
    setAllItems([]);
    setParentId(item);
    setActiveItem(item);
    setIsLoading(true);
    let roomsData = await MODULE_API.fetchRooms({
      id: item.id,
      body: {},
    });

    setIsLoading(false);
    // console.log("active", activeItem);
    // console.log("roomsData", roomsData);
    // roomsList =
    //   room.data &&
    //   room.data.map((property) => ({
    //     propertyName: property.name,
    //     room: rooms,
    //   }));
    rooms =
      roomsData &&
      roomsData.data &&
      roomsData.data.children &&
      roomsData.data.children.map((room) => ({
        id: room.id,
        room: room ? room.name : "N/A",
        name: room.name ? room.name : "N/A",
        value: room.total ? room.total : 0,
        images: room.images ? room.images : [],
        detail: room.detail ? room.detail : "",
        img: room.images && room.images[0] ? room.images[0] : tableimg,
        videos: room.videos ? room.videos : [],
      }));
    // console.log("rooms", rooms);
    setAllRooms(rooms);
    setHeading(true);

    dispatch(
      saveActiveProperty({
        id: item.id,
        children: roomsData && roomsData.data.children,
      })
    );
    dispatch(saveAllRooms(rooms));
  }

  async function inventoryReport() {
    if (
      (propertiesInfo &&
        propertiesInfo.allProperties &&
        propertiesInfo.allProperties.length === 0) ||
      (allProperties && allProperties.length === 0)
    ) {
      console.log("propertiesInfo", propertiesInfo);
      setIsLoading(true);
      setAllProperties([]);
      let inventories = await MODULE_API.fetchItems({
        moduleName: "PROPERTY",
        pageNum: 1,
        limit: 100,
        body: {},
      });
      setIsLoading(false);
      // console.log("new report", inventories.records);
      // console.log("inventories", inventories);
      propertiesList =
        inventories &&
        inventories.records &&
        inventories.records.map((properties) => ({
          id: properties.id,
          name: properties.name,
          total: properties.total ? properties.total : 0,
          img:
            properties.images && properties.images[0]
              ? properties.images[0]
              : tableimg,
          // description:
          //   "Lorem Ipsum Lorem Ipsum Lorem Ipsum, Lorem Ipsum Lorem Ipsum Lorem Ipsum",
          // setTotalValues(...totalValues + properties.total),
          // setTotalValues((totalValues) => totalValues + total)
          city: properties.city ? properties.city : "N/A",
          state: properties.state ? properties.state : "N/A",
          zip: properties.zip ? properties.zip : " N/A",
          type: properties.type,
          street: properties.street ? properties.street : "N/A",
          multiImg: properties.images,
          videos: properties.videos ? properties.videos : [],
        }));
      propertiesList &&
        propertiesList.map(
          (properties) => console.log("properties", properties.total)
          // setTotalValues((prev) => prev + properties.total)
        );
      const initialValue = 0;
      const sumWithInitial =
        propertiesList &&
        propertiesList.reduce(
          (accumulator, currentValue) => accumulator + currentValue.total,
          initialValue
        );
      console.log("sumWithInitial", sumWithInitial);
      setTotalValues(sumWithInitial);
      setAllProperties(propertiesList);
      dispatch(saveAllProperties(propertiesList));
    }
  }
  useEffect(() => {
    setAllProperties(propertiesInfo.allProperties);
  }, [propertiesInfo]);
  useEffect(() => {
    if (roomsInfo && roomsInfo.allrooms && roomsInfo.allrooms.length > 0) {
      setHeading(true);
      setAllRooms(roomsInfo.allrooms);
    }
  }, [roomsInfo]);
  useEffect(() => {
    if (itemsInfo && itemsInfo.allItems && itemsInfo.allItems.length > 0) {
      setAllItems(itemsInfo.allItems);
      setShowItems(true);
    }
  }, [itemsInfo]);

  async function handleModalCancel() {
    setShowPropertyAdd(false);
    setShowRoomAdd(false);
    setShowItemAdd(false);
    setShowUpdateProperty(false);
    setShowUpdateRoom(false);
    setShowUpdateItem(false);
    setModal(false);
  }
  function handleDelete(event, item, type) {
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to Delete this Property?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then(async (doDelete) => {
      setIsLoading(true);
      doDelete &&
        (await MODULE_API.removeClientModule({
          clientModules: [item.id],
        }));
      if (type == "property") {
        updateProperties();
        setActiveItem("");
        setAllRooms("");
        inventoryReport();
        return;
      } else if (type == "room") {
        if (activeItem.id) {
          await MODULE_API.getRecordTotal(activeItem.id, {
            attributes: ["total"],
          });
        }
        setAllItems("");
        setShowItems(false);
        setShowItemAdd(false);
      } else {
        await MODULE_API.getRecordTotal(activeRoom, {
          attributes: ["currentValue"],
        });
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
      }
      updateInventory(activeItem);
    });
  }

  function handleEditProperty(e, item) {
    setModal(true);
    setShowUpdateProperty(true);
    // console.log("event", e, "item", item);
    setUpdateProperty(item);
  }

  function handleEditRoom(e, item) {
    setModal(true);
    setShowUpdateRoom(true);
    console.log("event", e, "item", item);
    setUpdateRoom(item);
  }
  function handleViewRoom(e, item) {
    setModal(true);
    setShowUpdateRoom(true);
    console.log("event", e, "item", item);
    setUpdateRoom({ ...item, edit: true });
  }
  // const detaiRoom = () =>{
  //   <Detail/>
  // }
  async function handleEditItem(e, item) {
    const fetchroomInfo =
      roomsInfo && roomsInfo.allrooms
        ? roomsInfo.allrooms.find(
            (room) =>
              room.id === (roomsInfo.activeRoom && roomsInfo.activeRoom.id)
          )
        : null;
    console.log("room id is", fetchroomInfo, activeItem, parentId);
    updateInventory(activeItem);
    setUpdateItem(item);
    setIsLoading(true);
    let itemDetails = await MODULE_API.fetchRooms({
      id: item.id,
      body: {},
    });
    setIsLoading(false);
    setEditItemDetails(itemDetails);
    const bodyyy = {
      property: {
        ...(parentId ? parentId : activeItem),
        room: roomId ? roomId : fetchroomInfo.id,
      },
      data: { ...item },
      isUpdate: true,
      editItem: { ...itemDetails },
    };
    if (updateItem && editItemDetails) {
      setTimeout(() => {
        history.push(
          `/update_item/${item.id}/${parentId ? parentId.id : activeItem.id}/${
            roomId ? roomId.id : fetchroomInfo.id
          }`,
          bodyyy
        );
      }, 200);
    }
  }

  async function getAllItems(roomID) {
    await MODULE_API.fetchItems({
      moduleName: `ITEM`,
      pageNum: 1,
      limit: 10,
      body: {
        parentId: roomID,
      },
    });
  }

  const handleModalButton = () => {
    setModal(false);
    setShowPropertyAdd(false);
    setShowRoomAdd(false);
    setShowItemAdd(false);
    setShowUpdateItem(false);
    setShowUpdateProperty(false);
    setShowUpdateRoom(false);
  };
  const handleRoomModalButton = () => {
    setShowRoomAdd(!showRoomAdd);
  };

  function moneyFormatter(value) {
    // Create our number formatter.
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    let result = formatter.format(value);
    // console.log("Money :: ", result);
    return result;
  }
  return (
    <div>
      <Style.Main>
        <Style.Cards>
          <Style.SubCards
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Style.CardsHead>
              <h3 style={{ fontWeight: "bold" }}>Properties</h3>
            </Style.CardsHead>
            <Style.PropertyAdd
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1rem",
                width: "",
              }}
            >
              <div>
                <h3>Add Property</h3>
              </div>
              <div
                onClick={() => addProperty()}
                className="upload"
                style={{ width: "28px", height: "28px", cursor: "pointer" }}
              >
                <img
                  src={addIcon}
                  width={12}
                  height={12}
                  style={{ width: "16px", height: "16px" }}
                  alt="addicon"
                ></img>
              </div>
            </Style.PropertyAdd>
          </Style.SubCards>

          <Style.CardsMain
            style={{
              justifyContent:
                allProperties && allProperties.length > 0 ? "start" : "center",
              grid: allProperties && allProperties.length === 0 && "initial",
              padding: "8px",
              gap: "1rem",
            }}
          >
            {allProperties ? (
              allProperties.map((item, index) => (
                <Style.Card
                  key={index}
                  onClick={() => fetchRoom(item)}
                  active={item.id == activeItem}
                  style={{ padding: "0", overflow: "hidden" }}
                >
                  {/* Image Section */}
                  <div
                    style={{
                      padding: "1.5rem 1rem 0.5rem",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      height: "220px",
                      alignItems: "center",
                    }}
                  >
                    <Style.Img
                      src={item.img}
                      style={{
                        width: "auto",
                        height: "100%",
                        maxHeight: "200px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Header: Title and Actions */}
                  <Style.CardHeader>
                    <Style.CardTitle>{item.name}</Style.CardTitle>
                    <Style.CardIcons>
                      <Button
                        type="link"
                        icon="file-image"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          getSelectedRecords(item, "Images");
                        }}
                      />
                      <Button
                        type="link"
                        icon="video-camera"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          getSelectedRecords(item, "Videos");
                        }}
                      />
                      <Button
                        type="link"
                        icon="edit"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditProperty(e, item);
                        }}
                      />
                      <Link
                        to={{
                          pathname: `/property-detail/${item.id}`,
                          query: `id=${item.id}`,
                          state: item,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Button
                          type="link"
                          icon="eye"
                          style={{ color: "black", fontSize: "18px" }}
                        />
                      </Link>
                      <Button
                        type="link"
                        icon="delete"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(e, item, "property");
                        }}
                      />
                    </Style.CardIcons>
                  </Style.CardHeader>

                  {/* Main Value Section */}
                  <Style.CardValueSection>
                    <Style.CardValue>
                      {item.total ? moneyFormatter(item.total) : "$0.00"}
                    </Style.CardValue>
                    <Style.CardLabel>Total Value</Style.CardLabel>
                  </Style.CardValueSection>

                  {/* Footer Stats */}
                  <Style.StatsContainer>
                    <Style.StatBox>
                      <div style={{ fontSize: "1.2rem" }}>🏠</div>
                      <Style.StatLabel>Type</Style.StatLabel>
                      <Style.StatValue>
                        {item.type ? item.type : "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>

                    <Style.StatBox>
                      <div style={{ fontSize: "1.2rem" }}>📍</div>
                      <Style.StatLabel>Location</Style.StatLabel>
                      <Style.StatValue>
                        {item.city && item.state
                          ? `${item.city}, ${item.state}`
                          : item.city || item.state || "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>

                    <Style.StatBox last>
                      <div style={{ fontSize: "1.2rem" }}>📋</div>
                      <Style.StatLabel>SubType</Style.StatLabel>
                      <Style.StatValue>
                        {item.subType ? item.subType : "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>
                  </Style.StatsContainer>
                </Style.Card>
              ))
            ) : (
              <h1
                style={{
                  marginTop: "6rem",
                  width: "max-content",
                  textAlign: "center",
                }}
              >
                No Items to Display for this Asset Allocation.
              </h1>
            )}
          </Style.CardsMain>
        </Style.Cards>

        <div
          style={{
            display: "flex",
            width: "100%",
            padding: "1rem 1rem 0rem 1rem",
          }}
        >
          {activeItem && allHeading ? (
            <Style.SubCards
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Style.CardsHead>
                <h3 style={{ fontWeight: "bold", fontSize: "22px" }}>
                  Inventory Details
                </h3>
              </Style.CardsHead>
            </Style.SubCards>
          ) : null}
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            padding: "1rem",
            gap: "2rem",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          {/* Rooms Section */}
          <div
            style={{
              flex: "1",
              minWidth: "300px",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3 style={{ fontSize: "20px", fontWeight: "600", margin: 0 }}>
                Rooms
              </h3>
              {activeItem && allHeading && (
                <Button
                  type="primary"
                  icon="plus"
                  style={{ backgroundColor: "#2a3da3", borderColor: "#2a3da3" }}
                  onClick={() => addRoom()}
                >
                  Add Room
                </Button>
              )}
            </div>

            <Style.Rooms
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                gap: "1rem",
                width: "100%",
              }}
            >
              {allRooms &&
                allRooms.map((item, index) => (
                  <Style.Card
                    key={index}
                    onClick={() => fetchItem(item)}
                    style={{
                      borderColor:
                        activeRoom !== item.id ? colors.green : "none",
                      padding: "0",
                      overflow: "hidden",
                      minWidth: "280px",
                    }}
                    active={item.id == activeRoom}
                  >
                    {/* Image Section */}
                    <div
                      style={{
                        padding: "1.5rem 1rem 0.5rem",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        height: "220px",
                        alignItems: "center",
                      }}
                    >
                      <Style.Img
                        src={item.img}
                        style={{
                          width: "auto",
                          height: "100%",
                          maxHeight: "200px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Image/Video Gallery Buttons */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "0.5rem 0",
                        gap: "0.5rem",
                      }}
                    >
                      <Button
                        type="link"
                        style={{ fontSize: "21px", color: "#2a3da3" }}
                        icon="file-image"
                        onClick={(e) => {
                          e.stopPropagation();
                          getSelectedRecords(item, "Images");
                        }}
                      />
                      <Button
                        type="link"
                        style={{ fontSize: "21px", color: "#2a3da3" }}
                        icon="video-camera"
                        onClick={(e) => {
                          e.stopPropagation();
                          getSelectedRecords(item, "Videos");
                        }}
                      />
                    </div>

                    {/* Header: Title and Actions */}
                    <Style.CardHeader>
                      <Style.CardTitle>{item.room}</Style.CardTitle>
                      <Style.CardIcons>
                        <Button
                          type="link"
                          icon="edit"
                          style={{ color: "black", fontSize: "18px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditRoom(e, item);
                          }}
                        />
                        <Button
                          type="link"
                          icon="eye"
                          style={{ color: "black", fontSize: "18px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewRoom(e, item);
                          }}
                        />
                        <Button
                          type="link"
                          icon="delete"
                          style={{ color: "black", fontSize: "18px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(e, item, "room");
                          }}
                        />
                      </Style.CardIcons>
                    </Style.CardHeader>

                    {/* Main Value Section */}
                    <Style.CardValueSection>
                      <Style.CardValue>
                        {item.value ? moneyFormatter(item.value) : "$0.00"}
                      </Style.CardValue>
                      <Style.CardLabel>Room Value</Style.CardLabel>
                    </Style.CardValueSection>

                    {/* Footer Stats */}
                    <Style.StatsContainer>
                      <Style.StatBox>
                        <div style={{ fontSize: "1.2rem" }}>🏠</div>
                        <Style.StatLabel>Room Name</Style.StatLabel>
                        <Style.StatValue
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100px",
                          }}
                          title={item.name}
                        >
                          {item.name}
                        </Style.StatValue>
                      </Style.StatBox>

                      <Style.StatBox last>
                        <div style={{ fontSize: "1.2rem" }}>📊</div>
                        <Style.StatLabel>Property</Style.StatLabel>
                        <Style.StatValue
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100px",
                          }}
                          title={item.detail || "N/A"}
                        >
                          {activeItem.name || "N/A"}
                        </Style.StatValue>
                      </Style.StatBox>
                    </Style.StatsContainer>
                  </Style.Card>
                ))}
            </Style.Rooms>
          </div>

          {/* Items Section */}
          <div
            style={{
              display: "flex",
              flex: "3",
              minWidth: "300px",
              flexDirection: "column",
              // width:"70%",
              gap: "1rem",
            }}
          >
            {showItems && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3 style={{ fontSize: "20px", fontWeight: "600", margin: 0 }}>
                  Items
                </h3>
                <Button
                  type="primary"
                  icon="plus"
                  style={{ backgroundColor: "#2a3da3", borderColor: "#2a3da3" }}
                  onClick={() => addItem(allItems)}
                >
                  Add Item
                </Button>
              </div>
            )}

            {data === false ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "1.5rem",
                  width: "100%",
                }}
              >
                {allItems &&
                  allItems.map((item, index) => (
                    <Style.Card
                      key={item.id}
                      style={{
                        padding: "0",
                        overflow: "hidden",
                        cursor: "default",
                      }}
                      active={item.id == activeRoom}
                    >
                      {/* Image Section */}
                      <div
                        style={{
                          padding: "1.5rem 1rem 0.5rem",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          height: "200px",
                          alignItems: "center",
                          background: "#f9f9f9",
                        }}
                      >
                        <img
                          src={item.img}
                          alt={item.name}
                          style={{
                            width: "auto",
                            height: "100%",
                            maxHeight: "180px",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>

                      {/* Header: Title and Actions */}
                      <Style.CardHeader>
                        <Style.CardTitle>{item.name}</Style.CardTitle>
                        <Style.CardIcons>
                          <Button
                            type="link"
                            icon="edit"
                            style={{ color: "black", fontSize: "18px" }}
                            onClick={(e) => {
                              handleEditItem(e, item);
                            }}
                          />
                          <Link
                            to={{
                              pathname: `/item-detail/${item.id}`,
                              query: `id=${item.id}`,
                              state: item,
                            }}
                          >
                            <Button
                              type="link"
                              icon="eye"
                              style={{ color: "black", fontSize: "18px" }}
                            />
                          </Link>
                          <Button
                            type="link"
                            icon="delete"
                            style={{ color: "black", fontSize: "18px" }}
                            onClick={(e) => {
                              handleDelete(e, item);
                            }}
                          />
                        </Style.CardIcons>
                      </Style.CardHeader>

                      {/* Loan Status Badge */}
                      {item.isLoan && (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "0.5rem",
                            background: "#fff1f0",
                            borderTop: "1px solid #ffccc7",
                            borderBottom: "1px solid #ffccc7",
                          }}
                        >
                          <span
                            style={{
                              color: "#cf1322",
                              fontWeight: "600",
                              fontSize: "0.9rem",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            🔴 Currently Loaned
                          </span>
                        </div>
                      )}

                      {/* Main Value Section */}
                      <Style.CardValueSection>
                        <Style.CardValue>
                          {item.currentValue
                            ? `$${item.currentValue
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "$0.00"}
                        </Style.CardValue>
                        <Style.CardLabel>Current Value</Style.CardLabel>
                      </Style.CardValueSection>

                      {/* Footer Stats */}
                      <Style.StatsContainer>
                        <Style.StatBox>
                          <Style.StatLabel>Property</Style.StatLabel>
                          <Style.StatValue
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "80px",
                            }}
                            title={activeItem ? activeItem.name : "N/A"}
                          >
                            {activeItem ? activeItem.name : "N/A"}
                          </Style.StatValue>
                        </Style.StatBox>

                        <Style.StatBox>
                          <Style.StatLabel>Room</Style.StatLabel>
                          <Style.StatValue
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "80px",
                            }}
                            title={item.room}
                          >
                            {item.room || "N/A"}
                          </Style.StatValue>
                        </Style.StatBox>
                        <Style.StatBox>
                          <Style.StatLabel>Quantity</Style.StatLabel>
                          <Style.StatValue
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "80px",
                            }}
                            title={item ? item.quantity : "N/A"}
                          >
                          {item ? item.quantity : "N/A"}
                          </Style.StatValue>
                        </Style.StatBox>

                        <Style.StatBox last>
                          <Style.StatLabel>Total Value</Style.StatLabel>
                          <Style.StatValue>
                            {item.value
                              ? `$${item.value
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                              : "$0.00"}
                          </Style.StatValue>
                        </Style.StatBox>
                      </Style.StatsContainer>

                      {/* Action Buttons */}
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                          padding: "1rem",
                          borderTop: "1px solid #f0f0f0",
                          background: "#fafafa",
                        }}
                      >
                        <Button
                          type="primary"
                          style={{
                            flex: 1,
                            height: "40px",
                            backgroundColor: item.isLoan
                              ? "#09A84D"
                              : "#2a3da3",
                            borderColor: item.isLoan ? "#09A84D" : "#2a3da3",
                            fontFamily: "Poppins, sans-serif",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={(e) => {
                            if (item.isLoan) {
                              handleReturnItem(item.id);
                            } else {
                              setAddLoanModal(true);
                              setFormDataLoan({
                                ...formDataLoan,
                                ["itemId"]: item.id,
                              });
                            }
                          }}
                        >
                          {item.isLoan ? "Return" : "Loan"}
                        </Button>
                        <Button
                          type="primary"
                          style={{
                            flex: 1,
                            height: "40px",
                            backgroundColor: "#2a3da3",
                            borderColor: "#2a3da3",
                            fontFamily: "Poppins, sans-serif",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={(e) => {
                            setAddBorrowModal(true);
                            setFormDataBorrow({
                              ...formDataLoan,
                              ["itemId"]: item.id,
                            });
                          }}
                        >
                          Borrow
                        </Button>
                      </div>
                    </Style.Card>
                  ))}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                }}
              >
                <h3 style={{ color: "#999" }}>NO ITEM FOUND</h3>
              </div>
            )}
          </div>
        </div>
      </Style.Main>
      <div>
        <Modal
          width={"58rem"}
          visible={isModal}
          footer={null}
          onCancel={handleModalCancel}
          style={{ width: showUpdateItem && "fit-content" }}
          bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}
        >
          {showPropertyAdd && (
            <PropertyAdd
              handleModalButton={handleModalButton}
              updateProperties={updateProperties}
            />
          )}
          {showRoomAdd && (
            <RoomAdd
              handleModalButton={handleModalButton}
              updateInventory={() => updateInventory(activeItem)}
              activeProperty={activeItem}
              parentId={parentId}
            />
          )}

          {showUpdateProperty && (
            <PropertyUpdate
              handleModalButton={handleModalButton}
              data={updateProperty}
              updateProperty={updateProperties}
            />
          )}
          {showUpdateRoom && (
            <RoomUpdate
              handleModalButton={handleModalButton}
              data={updateRoom}
              updateInventory={() => updateInventory(activeItem)}
              activeProperty={activeItem}
            />
          )}
          {/* {showUpdateItem && (
            <ItemUpdate
              data={updateItem}
              property={{ ...parentId, room: roomId }}
              isUpdate={true}
              editItem={editItemDetails}
            />
          )} */}
        </Modal>
        <Modal
          visible={detailsModal}
          footer={null}
          onOk={handleCancel}
          onCancel={handleCancel}
          closable={true}
          centered
          bodyStyle={{
            padding: 0,
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Modal Header */}
          <div
            style={{
              padding: "1.5rem 2rem",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "1.5rem",
                fontWeight: "600",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Inventory Gallery
            </h2>
            <p
              style={{
                margin: "0.5rem 0 0 0",
                fontSize: "0.9rem",
                opacity: 0.9,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {currentRecord && currentRecord.name} Details
            </p>
          </div>

          {/* Modal Body */}
          <div style={{ padding: "2rem" }}>
            <div
              style={{
                maxHeight: "500px",
                overflow: "auto",
                paddingRight: "0.5rem",
              }}
            >
              {currentRecord && currentRecord.files.length > 0 ? (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "1.5rem",
                  }}
                >
                  {currentRecord.name === "Images" &&
                    currentRecord.files.map((imgUrl, index) => (
                      <a
                        key={index}
                        href={imgUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          position: "relative",
                          display: "block",
                          borderRadius: "12px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transition: "all 0.3s ease",
                          textDecoration: "none",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow =
                            "0 8px 20px rgba(0,0,0,0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(0,0,0,0.1)";
                        }}
                      >
                        <img
                          src={imgUrl}
                          alt={`Image ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background:
                              "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                            padding: "1rem 0.75rem 0.5rem",
                            color: "white",
                            fontSize: "0.85rem",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Image {index + 1}
                        </div>
                      </a>
                    ))}
                  {currentRecord.name === "Videos" &&
                    currentRecord.files.map((videoUrl, index) => {
                      const getVideoType = (url) => {
                        const ext = url.split(".").pop().toLowerCase();
                        const types = {
                          mp4: "video/mp4",
                          webm: "video/webm",
                          ogg: "video/ogg",
                          mov: "video/quicktime",
                        };
                        return types[ext] || "video/mp4";
                      };

                      return (
                        <div
                          key={index}
                          style={{
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <video
                            controls
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "cover",
                              display: "block",
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              document.getElementById(
                                `fallback-${index}`
                              ).style.display = "block";
                            }}
                          >
                            <source
                              src={videoUrl}
                              type={getVideoType(videoUrl)}
                            />
                            Your browser does not support the video tag.
                          </video>
                          <div
                            id={`fallback-${index}`}
                            style={{
                              display: "none",
                              padding: "1rem",
                              textAlign: "center",
                              background: "#f5f5f5",
                            }}
                          >
                            <p
                              style={{
                                color: "#ff4d4f",
                                margin: "0 0 0.5rem 0",
                              }}
                            >
                              ⚠️ Video format not supported.
                            </p>
                            <button
                              onClick={async () => {
                                try {
                                  const response = await fetch(videoUrl);
                                  const blob = await response.blob();
                                  const blobUrl =
                                    window.URL.createObjectURL(blob);
                                  const a = document.createElement("a");
                                  a.href = blobUrl;
                                  a.download = `video-${index}`;
                                  document.body.appendChild(a);
                                  a.click();
                                  document.body.removeChild(a);
                                  window.URL.revokeObjectURL(blobUrl);
                                } catch (error) {
                                  alert("Failed to download video.");
                                  console.error("Download error:", error);
                                }
                              }}
                              style={{
                                color: "#2a3da3",
                                background: "white",
                                border: "1px solid #2a3da3",
                                padding: "0.5rem 1rem",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontFamily: "Poppins, sans-serif",
                              }}
                            >
                              Download Video
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "3rem",
                    color: "#999",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  <h3>No Data to Show</h3>
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
      {addLoanModal && (
        <LoanItemModal
          title={"Add Loan"}
          open={addLoanModal}
          handleChange={handleInputChangeLoan}
          handleCancel={handleCancelAddLoanModal}
          data={formDataLoan && formDataLoan}
          handleSave={handleSaveAddLoanModal}
        />
      )}
      {addBorrowModal && (
        <BorrowItemModal
          title={"Add Borrow"}
          open={addBorrowModal}
          handleChange={handleInputChangeBorrow}
          handleCancel={handleCancelAddBorrowModal}
          data={formDataBorrow && formDataBorrow}
          handleSave={handleSaveAddBorrowModal}
        />
      )}
      <Loader isLoading={isLoading} />
    </div>
  );
}

export default inventory;
